export enum FilterRole {
  ALL = 'ALL',
  FAVORITES = 'FAVORITES',
  PRIVATE = 'PRIVATE',
  HAS_OFFERS = 'HAS_OFFERS',
  OFFER_SUBMITTED = 'OFFER_SUBMITTED',
  REJECTED_PROPOSALS = 'REJECTED_PROPOSALS',
  RETRACTED_PROPOSALS = 'RETRACTED_PROPOSALS',
  RETRACTED_OFFERS = 'RETRACTED_OFFERS',
  EXPIRED = 'EXPIRED',
  MY_PROPOSALS = 'MY_PROPOSALS',
  SUBSTITUTES = 'SUBSTITUTES',
}
